var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('Title', {
    attrs: {
      "text-start": "",
      "font-weight": 600,
      "font-size": 14,
      "title": "Документ о воинской обязанности",
      "append-icon": "mdi-trash-can-outline"
    },
    on: {
      "click:append-outer": _vm.removeMilitary
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setMilitary
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          class: {
            'required': _vm.requiredIfMan
          }
        }, [_vm._v("Серия")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.military.series,
      callback: function callback($$v) {
        _vm.$set(_vm.military, "series", $$v);
      },
      expression: "military.series"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Введите данные",
      "rounded": "",
      "outlined": "",
      "dense": ""
    },
    on: {
      "input": _vm.setMilitary
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          class: {
            'required': _vm.requiredIfMan
          }
        }, [_vm._v("Номер")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.military.number,
      callback: function callback($$v) {
        _vm.$set(_vm.military, "number", $$v);
      },
      expression: "military.number"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('DatePicker', {
    attrs: {
      "label": "Дата выдачи",
      "required": _vm.requiredIfMan,
      "prop-date": _vm.military.issueDate
    },
    on: {
      "set-date": _vm.setIssueDate
    }
  })], 1), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('FileInput', {
    attrs: {
      "title": "Файл документа о воинской обязанности",
      "ref-id": _vm.military.id,
      "ref-class-name": "Military"
    },
    on: {
      "set-files": _vm.setFiles
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }